import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Profile.css";

const ROLE_LABELS = {
  superadmin: "Super Admin",
  admin: "Admin",
  user: "User",
};

function Profile() {
  const username = localStorage.getItem("username");
  const role = localStorage.getItem("role");
  const token = localStorage.getItem("token");

  const authHeaders = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const [profile, setProfile] = useState({
    username: username || "",
    email: "",
    telephone: "",
    department: "",
    position: "",
    profilePicture: "",
  });

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  useEffect(() => {
  fetchProfile();

  // eslint-disable-next-line
}, []);

  const fetchProfile = async () => {
    try {
      const res = await axios.get(
        `https://hrpsc.swisstekaluminium.com/api/auth/profile/${username}`,
        authHeaders
      );

      setProfile({
        username: res.data.username || "",
        email: res.data.email || "",
        telephone: res.data.telephone || "",
        department: res.data.department || "",
        position: res.data.position || "",
        profilePicture: res.data.profilePicture || "",
      });

      if (res.data.profilePicture) {
        localStorage.setItem("profilePicture", res.data.profilePicture);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleProfileChange = (e) => {
    setProfile({
      ...profile,
      [e.target.name]: e.target.value,
    });
  };

  const uploadProfilePicture = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const imageData = new FormData();

    imageData.append("profilePicture", file);

    try {
      const res = await axios.post(
        "https://hrpsc.swisstekaluminium.com/api/auth/upload-profile-picture",
        imageData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setProfile({
        ...profile,
        profilePicture: res.data.imagePath,
      });

      alert("Profile picture uploaded. Now click Update Profile.");
    } catch (err) {
      console.log(err.response?.data || err);
      alert(err.response?.data?.message || "Image upload failed");
    }
  };

  const updateProfile = async () => {
    try {
      const res = await axios.put(
        "https://hrpsc.swisstekaluminium.com/api/auth/update-profile",
        {
          oldUsername: username,
          newUsername: profile.username,
          email: profile.email,
          telephone: profile.telephone,
          department: profile.department,
          position: profile.position,
          profilePicture: profile.profilePicture,
        },
        authHeaders
      );

      localStorage.setItem("username", res.data.user.username);
      localStorage.setItem(
        "profilePicture",
        res.data.user.profilePicture || profile.profilePicture || ""
      );

      await axios.post(
        "https://hrpsc.swisstekaluminium.com/api/history",
        {
          module: "Profile",
          action: "Updated Profile",
          description: `${res.data.user.username} updated profile details`,
          username: res.data.user.username,
          role,
        },
        authHeaders
      );

      alert("Profile Updated Successfully");

      window.location.reload();
    } catch (err) {
      console.log(err);
      alert(err.response?.data?.message || "Profile update failed");
    }
  };

  const changePassword = async () => {
    if (!currentPassword || !newPassword) {
      alert("Please enter current and new password");
      return;
    }

    try {
      await axios.put(
        "https://hrpsc.swisstekaluminium.com/api/auth/change-password",
        {
          username,
          currentPassword,
          newPassword,
        },
        authHeaders
      );

      await axios.post(
        "https://hrpsc.swisstekaluminium.com/api/history",
        {
          module: "Profile",
          action: "Changed Password",
          description: `${username} changed password`,
          username,
          role,
        },
        authHeaders
      );

      alert("Password Changed Successfully");

      setCurrentPassword("");
      setNewPassword("");
    } catch (err) {
      console.log(err);
      alert(err.response?.data?.message || "Password change failed");
    }
  };

  const initials = (profile.username || username || "?")
    .trim()
    .slice(0, 2)
    .toUpperCase();

  const roleClass = `role-${role || "user"}`;
  const roleLabel = ROLE_LABELS[role] || role || "User";

  return (
    <div className="profile-page">
      <div className="profile-shell">
        <header className="profile-hero">
          <span className="eyebrow">Account</span>
          <h1>My Profile</h1>
          <p className="subtitle">
            View and update your account information
          </p>
        </header>

        <div className={`id-badge ${roleClass}`}>
          <span className="badge-punch" aria-hidden="true"></span>

          <div className="badge-body">
            <div className="badge-avatar">
              {profile.profilePicture ? (
                <img src={profile.profilePicture} alt={profile.username} />
              ) : (
                <span>{initials}</span>
              )}
            </div>

            <div className="badge-meta">
              <h2>{profile.username}</h2>
              <span className="role-pill">{roleLabel}</span>
              <small>{profile.position || "No position added"}</small>
            </div>
          </div>

          <div className="badge-stripe"></div>
        </div>

        <section className="record-section">
          <div className="record-header">
            <h3>Edit account details</h3>
            <span className="record-hint">Changes apply after you save</span>
          </div>

          <div className="record-grid">
            <div className="field field-file">
              <label>Profile picture</label>
              <input
                type="file"
                accept="image/png,image/jpeg,image/jpg"
                onChange={uploadProfilePicture}
              />
            </div>

            <div className="field">
              <label>Username</label>
              <input
                type="text"
                name="username"
                value={profile.username}
                onChange={handleProfileChange}
              />
            </div>

            {role !== "user" && (
              <div className="field">
                <label>Company email address</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter company email"
                  value={profile.email}
                  onChange={handleProfileChange}
                />
              </div>
            )}

            <div className="field">
              <label>Telephone number</label>
              <input
                type="text"
                name="telephone"
                placeholder="Enter telephone number"
                value={profile.telephone}
                onChange={handleProfileChange}
              />
            </div>

            <div className="field">
              <label>Department</label>
              <input
                type="text"
                name="department"
                placeholder="Enter department"
                value={profile.department}
                onChange={handleProfileChange}
              />
            </div>

            <div className="field">
              <label>Position</label>
              <input
                type="text"
                name="position"
                placeholder="Enter position"
                value={profile.position}
                onChange={handleProfileChange}
              />
            </div>
          </div>

          <button className="btn-primary" onClick={updateProfile}>
            Update profile
          </button>
        </section>

        {role !== "user" && (
          <section className="record-section">
            <div className="record-header">
              <h3>Change password</h3>
              <span className="record-hint">Use a strong, unique password</span>
            </div>

            <div className="record-grid record-grid-narrow">
              <div className="field">
                <label>Current password</label>
                <input
                  type="password"
                  placeholder="Enter current password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                />
              </div>

              <div className="field">
                <label>New password</label>
                <input
                  type="password"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>
            </div>

            <button className="btn-secondary" onClick={changePassword}>
              Change password
            </button>
          </section>
        )}
      </div>
    </div>
  );
}

export default Profile;